import { MessageAPI } from "../api";
import moment from 'moment'
import Helper from "../plugins/Helper/Helper";
export class Message {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createMessage(payload) {
    const { data } = await MessageAPI.createMessage(payload);
    return new Message(data.result);
  }
  static async getMessages(payload) {
    const { data } = await MessageAPI.getMessages(payload);
    return data.result.map(item => new Message(item));  
  }
}
